import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

const OrgAdminContainer = ({
  children,
  isOrganizationAdmin,
  isTeamAdmin,
}) => {
  if (isOrganizationAdmin) {
    return children[1];
  }

  if (!isOrganizationAdmin && isTeamAdmin) {
    return children[0];
  }

  return <Redirect to="/dashboard/tests" />;
};

OrgAdminContainer.propTypes = {
  children: PropTypes.node.isRequired,
  isOrganizationAdmin: PropTypes.bool.isRequired,
  isTeamAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ user }) => ({
  isTeamAdmin: user.get('is_team_admin'),
  isOrganizationAdmin: user.get('is_organization_admin'),
});

export default connect(mapStateToProps)(OrgAdminContainer);
export { OrgAdminContainer, mapStateToProps };
